<template>
	<div>		
		<div class="scorebadge-wrapper">
			<v-avatar size="32" class="ml-4 mb-5 mt-3 mr-3 remove_clone">
				<span :class="color + '--text'">{{score}}</span>
			</v-avatar>
		</div>					
		<p class="primary2--text">Reifegrad nach KHZG</p>
	</div>

</template>
<style lang="less">
	.scorebadge-wrapper {
		display: inline-block;
		background-image: url("../../../assets/images/logo_avatar.png");
		background-size: contain;
		background-position: center center;
	}
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	// import - from "@/components/"
	export default {
		name: "ScoreBadge", 
		props: {
			small: {type: Boolean, default: false },
			level: {},

		},
		data: () => {
			return {

			}
		},
		// components: {

		// },
		computed: {
			...Vuex.mapState( {
				assessments: state => state.assessments || []
			}),
			color(){
				return this.scoreColor( this.score )
			},
			assessment(){ 
				return this.assessments[0]
			},
			score(){
				if( !this.assessment){
					return 0;
				}
				else{
					return this.assessment.scores[this.level];
				}
			},
		
		},
		// methods: {
		// }
		// created(){
			
		// }

	}
</script>"